module.exports = __webpack_public_path__ + "static/media/logo.2ebd726b.png";